'use client';

import { Suspense, useEffect, type ReactNode } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { useIsMobileLayout } from '@workspace/utils/useBreakpoint';
import { ApplicationProviders } from '@/contexts/app';
import { getInviteCodeForRiskSession } from '@/features/referral/shared';
import { isInitialContentRoute } from '@/lib/initial-content';

function ProductCodePreload() {
    const pathname = usePathname();
    const search = useSearchParams().toString();
    const isMobile = useIsMobileLayout();
    useEffect(() => {
        if (!isInitialContentRoute(pathname ?? '')) return;
        const loading = pathname?.startsWith('/workspace')
            ? import('@/features/workspace/entry').then(entry => entry.preloadWorkspace(search, isMobile))
            : import('@/features/project/workbench').then(entry => entry.preloadProject());
        void loading.catch(() => { /* 正式页面的 Suspense/错误边界负责重试与呈现错误。 */ });
    }, [isMobile, pathname, search]);
    return null;
}

/** 业务输入在客户端边界注入；服务端布局不跨边界传函数。 */
export function ApplicationShell({ children }: { /** 区域内的页面内容。 */ children: ReactNode }) {
    return (
        <ApplicationProviders getInviteCode={getInviteCodeForRiskSession}>
            <Suspense fallback={null}><ProductCodePreload /></Suspense>
            {children}
        </ApplicationProviders>
    );
}
